import React from 'react'
import { TopBar } from 'prove-common'
import { AppLogo } from '../app-logo/AppLogo'

export const NewsListScreenTopBar: React.FC = () => {
  return (
    <TopBar
      logo={<AppLogo />}
      breadcrumbItems={[
        {
          label: 'Innstillinger',
          to: '/settings'
        },
        {
          label: 'Nyheter'
        }
      ]}
    />
  )
}
